import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import setting from './modules/setting'
import getters from './getters'

Vue.use(Vuex)

let msgCount = 0;

export default new Vuex.Store({
	modules: {
		account,
		setting,
		msgCount
	},
	mutations: {
		update (modules, [key, value]) {
			modules[key] = value
		},
	},
	getters,
})



// WEBPACK FOOTER //
// ./src/store/index.js